"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADiscoverer = exports.AAnnouncer = void 0;
class AAnnouncer {
    constructor(identifier) {
        this.identifier = identifier;
    }
}
exports.AAnnouncer = AAnnouncer;
class ADiscoverer {
    constructor(identifier, endpointDecoder) {
        this.identifier = identifier;
        this.endpointDecoder = endpointDecoder;
    }
}
exports.ADiscoverer = ADiscoverer;
